// import CookieManager from '../util/Cookies/CookieManager';

export default {
    init() {
        // Initialise cookie manager / popup
        // new CookieManager(true);

        /**
         * ------------------------------------------------------------------
         * Navigation Menu Start
         */

        let parentNavigationItems = document.querySelectorAll('li.primary-navigation__item--has-children');
        parentNavigationItems.forEach((element) => {
            const button = element.querySelector('.primary-navigation__button');

            const openElement = () => {
              element.classList.add('active');
              $(element).children('.primary-navigation__sub-menu').css('max-height', '550px');
            }

            const closeElement = () => {
              element.classList.remove('active');
              $(element).children('.primary-navigation__sub-menu').removeAttr('style');
            }

            button.addEventListener('mouseenter', () => {
              if (window.matchMedia('(min-width: 1200px)').matches) {
                openElement();
              }
            })

            button.addEventListener('click', () => {
                if (element.classList.contains('active')) {
                    closeElement();
                } else {
                    openElement();
                }
            });

            element.querySelector('.primary-navigation__sub-menu').addEventListener('mouseleave', evt => {
              // Check if sub-menu is already opened. If so, leave event handler early
              if (!evt.currentTarget.hasAttribute('style')) {
                return;
              }

              closeElement();
            })
        });
        /**
         * Navigation Menu End
         * ------------------------------------------------------------------
         */


        /**
         * ------------------------------------------------------------------
         * Burger Menu Start
         */
        const burgerMenu = {
          header: $('.main-header'),
          burgerBtn: $('.js-primary-menu-toggle'),
          mobileMenu: $('#menu-primary-navigation'),
          darkOverlay: $('.dark-overlay'),

          init() {
            this.burgerBtn.on('click', () => {
              if (this.mobileMenu.hasClass('js-navigation-open')) {
                this.close();
              } else {
                this.open();
              }

              // Tapping on dark overlay also triggers mobile-menu exit
              this.darkOverlay.on('click', () => {
                this.close();
              })
            })
          },

          open() {
            // Menu is closed, so open it
            this.mobileMenu.css({
              right: 0,
              top: this.header.outerHeight() + 'px',
            });

            // Darken main-wrapper
            this.darkOverlay.removeClass('dark-overlay--inactive');

            // Add class to menu to signal that it is open
            this.mobileMenu.addClass('js-navigation-open');

            // Remove scrolling ability in body
            $('body').addClass('no-overflow');
          },

          close() {
            // Menu is open, so close it
            this.mobileMenu.css('right', '-100%');

            // Remove dark main-wrapper overlay
            this.darkOverlay.addClass('dark-overlay--inactive');

            // Remove class from menu to signal that it is closed
            this.mobileMenu.removeClass('js-navigation-open');

            // Allow scrolling ability in body once more
            $('body').removeClass('no-overflow');
          },
        }

        burgerMenu.init();

        /**
         * Burger Menu End
         * ------------------------------------------------------------------
         */
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        /**
         * ABOUT PAGE
         */
        if ($('.template-about').length !== 0) {
          $('.about-box__info-icon').on('click', function() {
            const imageCaptionElement = $(this).siblings('.about-box__image-caption');

            if (imageCaptionElement.css('opacity') === '0') {
              // image-caption element is not displayed, so make it display
              imageCaptionElement.css({'opacity': 1, 'z-index': 1});
            }
          });

          $('.about-box__image-caption-close-btn').on('click', function() {
              // image-caption element is displayed, so remove style attribute to return to default
              $(this).parent().removeAttr('style');
          })
        }

        /**
         * PROJECTS-OVERVIEW PAGE
         */
        if ($('.template-projects-overview').length !== 0) {
          /**
           * Events handled from the button that the user clicks on to open / close the dropdown menu.
           */
          $('.select-box__button').on('click', function() {
            const dropdownList = $(this).next('.select-box__dropdown-box');

            // If menu is closed, open it - otherwise, close it.
            dropdownList.toggleClass('select-box__dropdown-box--visible');
          });

          /**
           * Each dropdown menu item, whether one or multiple.
           */
          $('.select-box__dropdown-box-item').on('click', function() {
            // Item has been selected, so close menu and mark it as the selected option
            const parentBox = $(this).closest('.select-box');
            const parentDropdown = $(this).parent('.select-box__dropdown-box');
            const parentBtn = parentDropdown.prev('.select-box__button');
            const submitForm = $('.filter-projects__form');

            // Modify data attribute of button as well as text with new selected value.
            parentBtn.data('value', $(this).data('value'));
            parentBtn.text($(this).text());

            // Add special highlight around button if value other than default is selected.
            // If default value is selected, remove special highlight
            if ($(this).data('value') !== 'default') {
              parentBtn.addClass('select-box__button--selected');
            } else {
              parentBtn.removeClass('select-box__button--selected');
            }

            // Close dropdown menu.
            parentDropdown.removeClass('select-box__dropdown-box--visible');

            // Add value to hidden input field.
            $(submitForm.children()).filter('[name=' + parentBox.data('name') + ']').attr('value', $(this).data('value'));

            // Disable other input fields if their value is empty or default (this prevents them showing up in URL)
            $(submitForm.children()).map(function(index, element) {
              if (element.value.length === 0 || element.value === 'default') {
                element.setAttribute('disabled', '');
              }
            })
            
            // Trigger submit event.
            submitForm.submit();
          })

          /**
           * Close dropdown menu when user clicks outside of it.
           */
          $('.select-box__button').on('focusout', function() {
            $('.select-box__dropdown-box').removeClass('select-box__dropdown-box--visible');
          })
        }

        /**
         * PROJECTS-SINGLE PAGE
         */
        if ($('.single-projects').length !== 0) {
          $('.project-gallery__gallery-box').slick({
            draggable: false,
            infinite: false,
            centerMode: true,
            centerPadding: '0px',
            prevArrow: $('.gallery-navigation-box__left-arrow'),
            nextArrow: $('.gallery-navigation-box__right-arrow'),
            fitToView: false,
            slidesToShow: 2,
            variableWidth: false,
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 1399,
                settings: {
                  variableWidth: true,
                },
              },
            ],
          });

          // eslint-disable-next-line
          function updateNumber() {
            $('.current-image-number').text($('.slick-current').data('slick-index') + 1);
          }

          // Add extra class to .slick-list if exactly two images exist (it throws the design off a little)
          if ($('.project-gallery__gallery-box').find('.fancybox').length === 2) {
            $('.slick-list').addClass('slick-list--corrector');
          }

          $('.gallery-navigation-box__left-arrow').on('click', updateNumber);
          $('.gallery-navigation-box__right-arrow').on('click', updateNumber);

          $('.project-delivering-sdgs__image-box').slick({
            draggable: false,
            infinite: false,
            centerMode: false,
            prevArrow: $('.arrow-navigation-box__left-arrow'),
            nextArrow: $('.arrow-navigation-box__right-arrow'),
            width: 768,
            fitToView: false,
            slidesToShow: 3,
          })
        }

        /**
         * NEWS-SINGLE PAGE
         */
        if ($('.single-news').length !== 0) {
          // Adjust padding of main section based on height of standfirst
          // eslint-disable-next-line
          function adjustPadding() {
            const standfirstHeight = $('.page-header__standfirst').outerHeight();

            // Only do stuff when window width is 1200px or greater ('xl' Bootstrap breakpoint)
            if ($(window).width() > 1199) {
              $('.main-body').css({ 'padding-top': ((standfirstHeight / 2) + 81) + 'px' });
            } else {
              // Remove inline CSS at less than 1200px width if it exists as a result of the behaviour above
              if ($('.main-body').attr('style')) {
                $('.main-body').removeAttr('style');
              }
            }
          }

          adjustPadding();

          $(window).on('resize', adjustPadding);

          // Add smaller margin-bottom to image-box if it's followed by another image-box
          $('.section-box--image-box').each(function (index, imageBox) {
            if ($(imageBox).next().hasClass('section-box--image-box')) {
              $(imageBox).css({ 'margin-bottom': '20px' });
            }
          })
        }

        /**
         * PARTNER-WITH-US PAGE
         */
        if ($('.template-partner').length !== 0) {
          $('.start-your-journey__form').on('submit', function (evt) {
            evt.preventDefault();
          })
        }
    },
};
